export const MOCK_LOCAL_CONFIG = {
  zipCode: '',
  market: '',
};
